/****
* Central application configuration module that exposes
* environment-specific settings used throughout the application.
*
* Provides access to runtime configuration values such as
* API endpoints, application mode, base paths, and other
* global settings required during application startup and
* service initialization.
*/
const {
  VITE_API_BASE_URL,
  MODE,
  DEV,
  PROD,
  BASE_URL, // Vite's base public path
} = import.meta.env;

const RESOLVED_BASE_PATH = "/";

// if (typeof window !== "undefined") {
//   if (!VITE_API_BASE_URL) {
//     // Make loud in dev, keep silent in test/CI if needed
//     // You can switch to `throw` if you prefer
//     console.error("Missing VITE_API_BASE_URL in environment.");
//   }
// }

export const AppConfig = {
  mode: MODE,
  dev: DEV,
  prod: PROD,
  baseUrl: BASE_URL,
  basePath: RESOLVED_BASE_PATH,
  defaultGroupId: "DEFAULT",
  // API
  apiBaseUrl: VITE_API_BASE_URL,
} as const;
// console.warn("[AppConfig]", AppConfig);
